/**
 * Servicio con funciones puras para el reproductor de video
 */

export const PlayerService = {
  /**
   * Formatea un tiempo en segundos a cadena MM:SS o HH:MM:SS
   * @param {number} seconds
   * @returns {string} Tiempo formateado
   */
  formatTime(seconds = 0) {
    if (isNaN(seconds) || seconds < 0) return '00:00';

    const secNum = Math.floor(seconds);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor((secNum - hours * 3600) / 60);
    const secs = secNum - hours * 3600 - minutes * 60;

    const pad = (num) => String(num).padStart(2, '0');

    if (hours > 0) {
      return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
    }
    return `${pad(minutes)}:${pad(secs)}`;
  },

  /**
   * Calcula el porcentaje de posición horizontal de un marcador
   * @param {number} markerTime
   * @param {number} duration
   * @returns {number} Porcentaje de 0 a 100
   */
  calculatePercentage(markerTime, duration) {
    if (!duration || duration <= 0 || markerTime < 0) return 0;
    const percentage = (markerTime / duration) * 100;
    return Math.min(100, Math.max(0, percentage));
  }
};
